<div class="col-lg-12 content-scroll-screen parent">
  <div class="col-12 adduser-container-hgt">
    <div class="row mb-3">
      <div class="col-3">
        <div
          class="dasboard-bx1 d-flex justify-content-between align-items-center">
          <div>
            <h1>Orders</h1>
            <h4>{{ totalOrdersCount }}</h4>
          </div>
          <div class="chart-icon">
            <span class="material-symbols-outlined"> order_approve </span>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div
          class="dasboard-bx2 d-flex justify-content-between align-items-center">
          <div>
            <h1>Projects</h1>
            <h4>{{ totalProjectCount }}</h4>
          </div>

          <div class="chart-icon">
            <span class="material-symbols-outlined"> work_update </span>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div
          class="dasboard-bx1 d-flex justify-content-between align-items-center">
          <div>
            <h1>Sales Task</h1>
            <h4>{{ totalSalesTaskCount }}</h4>
          </div>

          <div class="chart-icon">
            <span class="material-symbols-outlined"> order_approve </span>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div
          class="dasboard-bx2 d-flex justify-content-between align-items-center">
          <div>
            <h1>Production Task</h1>
            <h4>{{ totalProductionTaskCount }}</h4>
          </div>
          <div class="chart-icon">
            <span class="material-symbols-outlined"> task </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row child">
      <div
        class="col-lg-8 dashboard-table dashboard-table-head mb-3 dashboardcard-size chart-1">
        <p-card header="">
          <jni-multi-line-chart
            *ngIf="qr2List.length > 0"
            [recordList]="qr2List"
            [type]="'orderWritten'"
            [title]="'Orders Written this month'"
            [xAxisTitle]="'Order Date'"
            [yAxisTitle]="'Order Count'">
          </jni-multi-line-chart>
        </p-card>
      </div>

      <div
        class="col-lg-4 dashboard-table dashboard-table-head mb-3 dashboardcard-size chart-2">
        <p-card header="">
          <jni-pie-chart
            *ngIf="qr1List.length > 0"
            [recordList]="qr1List"
            [type]="'readyToBill'"
            [title]="'Ready to Bill Report'"></jni-pie-chart>
        </p-card>
      </div>
      <div
        class="col-lg-6 dashboard-table dashboard-table-head mb-3 dashboardcard-size chart-3">
        <p-card header="">
          <jni-multi-line-chart
            *ngIf="qr4List.length > 0"
            [recordList]="qr4List"
            [type]="'customerAging'"
            [title]="'Chargeback Aging Report'"
            [xAxisTitle]="'Client'"
            [yAxisTitle]="'Amount Settled'"></jni-multi-line-chart>
        </p-card>
      </div>

      <div
        class="col-lg-6 dashboard-table dashboard-table-head mb-3 dashboardcard-size chart-4">
        <p-card header="">
          <jni-bar-chart
            *ngIf="invoicePostedthisMonth.length > 0"
            [type]="'invoicePosted'"
            [recordList]="invoicePostedthisMonth"
            [title]="'Invoices Posted this month'"
            [xAxisTitle]="'Job Name'"
            [yAxisTitle]="'Invoice Count'"></jni-bar-chart>
        </p-card>
      </div>

      <div
        class="col-lg-12 dashboard-table dashboard-table-head mb-3 dashboardcard-size-last chart-5">
        <p-card header="">
          <jni-bar-chart
            *ngIf="openClientCreditRecords.length > 0"
            [recordList]="openClientCreditRecords"
            [type]="'clientCreditReport'"
            [title]="'Open Client Credit Report'"
            [xAxisTitle]="'Client'"
            [yAxisTitle]="'Amount Not Settled'">
          </jni-bar-chart>
        </p-card>
      </div>
    </div>
  </div>
</div>
